import { render, staticRenderFns } from "./SubProcess.vue?vue&type=template&id=d6b2a158&scoped=true"
import script from "./SubProcess.vue?vue&type=script&lang=js"
export * from "./SubProcess.vue?vue&type=script&lang=js"
import style0 from "./SubProcess.vue?vue&type=style&index=0&id=d6b2a158&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b2a158",
  null
  
)

export default component.exports